export default "__VITE_ASSET__BusutgoE__"